module.exports = __webpack_public_path__ + "8ff166f6a22ce1df2bf06e9f06080608.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/img/logo_gobierno.png
// module id = 1709
// module chunks = 0